export const REDEEMED_WRITING_CREDIT = 'redeemedWritingCredit'
